import React from 'react'

const BoldText: React.FC<{ text: string | React.ReactNode }> = ({ text }) => <span style={{ color: 'black', fontWeight: 'bold' }}>{text}</span>

export default BoldText
